//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { format } from '@/tools/index.js'
import downloadImgs from '@/mixins/downloadImgs'
export default {
  mixins: [downloadImgs],
  data() {
    return {
      value: {
        tenantId: '',
        type: 'date',
        content: '',
      },
      currentValue: undefined,
      isCheck: true,
    }
  },
  props: {
    question: {
      type: Object,
      default() {
        return {}
      },
    },
    placeholder: {
      type: String,
      default: '选择时间',
    },
    questionVal: {
      type: String,
      default: '',
    },
    index: {
      type: Number,
    },
    readonly: {
      type: Boolean,
    },
    showScore: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  mounted() {
    this.question.v_answered && this.setHistroyAnswer()
  },
  watch: {
    questionVal(val) {
      if (!!val) {
        this.value = {
          tenantId: '',
          type: this.question.style,
          content: val,
        }
        this.currentValue = val ? new Date(val) : ''
      }
    },
  },
  methods: {
    // 根据type重组类型option
    getDateOption(key) {
      let scope = 1,
        range = false,
        time = false,
        type = ''

      switch (key) {
        case 'date':
          scope = 3
          range = false
          time = false
          type = 'yyyy-MM-dd'
          break
        case 'time':
          scope = 3
          range = false
          time = true
          break
        case 'datetime':
          scope = 5
          range = false
          time = false
          type = 'yyyy-MM-dd hh:mm'
          break
        case 'daterange':
          scope = 3
          range = true
          time = false
          type = 'yyyy-MM-dd'
          break
        case 'timerange':
          scope = 3
          range = true
          time = true
          break

        default:
          scope = 5
          range = true
          time = false
          type = 'yyyy-MM-dd hh:mm'
          break
      }

      return {
        scope,
        range,
        time,
        type,
      }
    },
    select() {
      let { scope, range, time, type } = this.getDateOption(this.question.style)
      new this.$DatePicker({
        value: this.currentValue,
        max: 2060,
        min: 1900,
        scope,
        range,
        time,
        onOk: (value, text) => {
          let myDate = this.getFormat(value, type)
          this.currentValue = value
          console.log(
            'currentValue: ',
            typeof this.currentValue,
            this.currentValue.length,
            this.currentValue
          )
          this.setDate(myDate)
          this.$emit('onSelectChange', {
            date: this.currentValue,
            formatDate: myDate,
          })
        },
      })
    },
    getFormat(value, type) {
      let myDate = undefined
      if (value.length) {
        if (typeof value[0] === 'number') return this.getTime(value)
        !value[0].length
          ? (myDate = [format(value[0], type), format(value[1], type)])
          : (myDate = [this.getTime(value[0]), this.getTime(value[1])])
      } else {
        myDate = format(value, type)
      }
      console.log('value: ', myDate)
      return myDate
    },
    getTime(value) {
      let h = value[0] < 10 ? '0' + value[0] : value[0]
      let m = value[1] < 10 ? '0' + value[1] : value[1]
      return h + ':' + m
    },
    setDate(value) {
      this.value.tenantId = this.question.tenantId
      this.value.content = value
      this.setAnswer(value)
    },
    setAnswer(value) {
      if (this.question.isAnswered) {
        return
      }
      // 设置题目答案
      this.$store.commit('setQuestionAnswered', {
        index: this.index,
        v_answered: true,
      })
      this.$store.commit('setQusstionUserAnswer', {
        index: this.index,
        v_answer: {
          tenantId: this.question.tenantId,
          type: 'date',
          content: JSON.stringify(value),
        },
      })
      // 如果当前为校验状态  则更新校验状态
      !this.isCheck && (this.isCheck = this.validate())
    },
    setHistroyAnswer() {
      let { tenantId, content } = this.question.v_answer
      this.value = {
        tenantId,
        type: 'date',
        content: JSON.parse(content),
      }
    },
    clear() {
      this.value = {
        tenantId: '',
        type: 'date',
        content: '',
      }
      this.currentValue = undefined
      this.$emit('onSelectChange', {
        date: this.currentValue,
        formatDate: '',
      })
      this.setAnswer('')
      // 如果当前为校验状态  则更新校验状态
      // console.log("isCheck: ", this.isCheck)
      // !this.isCheck && (this.isCheck = this.validate())
    },
    validate() {
      // 非必填跳过校验
      console.log('required: ', this.question.required)
      if (!this.question.required) return true

      // 校验  content的期望值："2020-09-01", "09:53", ["2020-09-01 09:53", "2020-11-01 19:53"]
      console.log(234, this.value, this.value.content.length)
      if (!this.value.content.length) {
        this.isCheck = false
        return false
      }
      // 设置题目已答
      this.$store.commit('setQuestionAnswered', {
        index: this.index,
        v_answered: true,
      })
      return true
    },
  },
}
